export default {
  state: {
    menuList: [],
    defaultActive: "",
  },
  mutations: {
    // 设置目录数据
    setMenuList: (state: any, menuList: any[]) => {
      state.menuList = menuList;
    },

    // 设置默认激活路由
    setDefaultActive(state: any, path: any) {
      state.defaultActive = path;
    },

    // 清空数据
    resetState: (state: any) => {
      state.menuList = [];
      state.defaultActive = "";
    },
  },
};
